<div [class.editMode]="isEditMode">
  <router-outlet> </router-outlet>
</div>
